function ProfileData(data) {
    this.data = data && this.createProfile(data);
}

ProfileData.prototype = Object.assign(ProfileData.prototype, {
    createProfile(data) {
        const { merchantDetails, paymentModeData } = data;
        const {
            name,
            email,
            entityCode,
            relationshipManagerId,
            checkoutLogoUrl,
            staticQREnabled,
        } = merchantDetails;
        console.log(merchantDetails,"isStaticQREnabled",staticQREnabled);
        return {
            name: name || '-',
            email: email || '-',
            checkoutLogoUrl: checkoutLogoUrl || null,
            entityCode: entityCode || '-',
            relationshipManagerId: relationshipManagerId || '-',
            paymentModeDetails: this.getPaymentDetails(paymentModeData),
            staticQREnabled,
        };
    },
    getPaymentDetails(paymentModeData) {
        let netBanking = [];
        let creditCard = [];
        let debitCard = [];
        if (paymentModeData && paymentModeData.paymentModeDetails) {
            const paymentList = paymentModeData.paymentModeDetails;

            netBanking = paymentList.filter(item => item.paymentType === 'NB');
            creditCard = paymentList.filter(item => item.paymentType === 'CC');
            debitCard = paymentList.filter(item => item.paymentType === 'DC');
        }

        return {
            netBanking,
            creditCard,
            debitCard,
        };
    },
});

export default ProfileData;
